module.exports = __webpack_public_path__ + "assets/35424a1d61770f00e0d3315d0d84832f.mp4";